import { Group, rem, Stack } from '@mantine/core';
import P4Medium from 'components/typography/P4Medium';
import P4Regular from 'components/typography/P4Regular';
import { useMemo } from 'react';

export interface RevisionItem {
  revisionId: number;
  revisionName: string;
}

interface RevisionListProps {
  revisions: RevisionItem[];
  unstyled?: boolean;
}

/**
 * Displays a list of revisions in a compact, styled container.
 */
export default function RevisionList({ revisions, unstyled = false }: RevisionListProps) {
  const style = useMemo(
    () => ({
      border: '1px solid #E9ECEF',
      borderRadius: '8px',
      backgroundColor: '#F8F9FA',
      padding: rem(12),
      paddingBottom: rem(8),
    }),
    []
  );

  if (revisions.length === 0) {
    return null;
  }

  return (
    <Stack spacing={4} style={unstyled ? undefined : style}>
      {revisions.map((revision) => (
        <Group key={revision.revisionId} spacing={8} noWrap align="start">
          <P4Medium color="gray.6">#{revision.revisionId}</P4Medium>
          <P4Regular color="gray.7" lineClamp={2}>
            {revision.revisionName}
          </P4Regular>
        </Group>
      ))}
    </Stack>
  );
}
